module.exports = __webpack_public_path__ + "img/file.dfc84016.svg";